import { render, staticRenderFns } from "./StudentIdentifier.vue?vue&type=template&id=75bc20d4&scoped=true&"
import script from "./StudentIdentifier.vue?vue&type=script&lang=js&"
export * from "./StudentIdentifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bc20d4",
  null
  
)

export default component.exports